import type { CustomIconProps } from '../types';

const Whisk = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '44'}
        height={height ?? '44'}
        viewBox="0 0 44 44"
        fill="none"
    >
        <path
            d="M21.9465 21.579C21.083 21.579 20.3809 13.26 20.3809 11.1594C20.3809 9.05883 21.083 7.33334 21.9465 7.33334C22.81 7.33334 23.5122 9.0505 23.5122 11.1594C23.5122 13.26 22.81 21.579 21.9465 21.579Z"
            stroke="#414042"
            strokeMiterlimit="10"
        />
        <path
            d="M21.9951 21.5795C19.7652 21.5795 17.9434 13.2688 17.9434 11.1682C17.9434 9.05929 19.7652 7.34213 21.9951 7.34213C24.225 7.34213 26.0563 9.05929 26.0563 11.1682C26.0563 13.2688 24.2345 21.5878 21.9951 21.5878V21.5795Z"
            stroke="#414042"
            strokeMiterlimit="10"
        />
        <path d="M21.9961 21.5791V23.9464V26.5472" stroke="#414042" strokeMiterlimit="10" />
        <path
            d="M21.8518 36.6667H22.1365C22.7601 36.6667 23.2656 36.2225 23.2656 35.6747V27.5307C23.2656 26.9829 22.7601 26.5388 22.1365 26.5388H21.8518C21.2282 26.5388 20.7226 26.9829 20.7226 27.5307V35.6747C20.7226 36.2225 21.2282 36.6667 21.8518 36.6667Z"
            stroke="#414042"
            strokeMiterlimit="10"
        />
    </svg>
);

export default Whisk;
